import { BLANK_VALUE } from "./formatters";
import { BooleanMeasurement } from "./BooleanMeasurement";
import { DailyMetricResponse } from "../../../../../protos/golang/generated/ts2/portal/metrics";
import { Measurement } from "./Measurement";
import { MetricBoolean, MetricNumber, MetricString } from "../../utils/metrics";
import React, { FC } from "react";

/**
 * @returns a display of the Metric value for the given data. This will call the given metric's
 * getValue function to display the value.
 **/
export const MetricMeasurement: FC<{
  data: DailyMetricResponse | undefined;
  metric: MetricBoolean | MetricNumber | MetricString;
  label?: "long" | "none";
}> = ({ data, metric, label }) => {
  if (data === undefined) {
    return BLANK_VALUE;
  } else if (metric.type === "boolean") {
    return (
      <BooleanMeasurement
        i18nKey={metric.i18nKey ?? metric.id}
        value={metric.getValue(data)}
      />
    );
  } else if (metric.type === "number") {
    const value = metric.getValue(data);
    return (
      <Measurement
        cycleSlot={metric.cycleSlot}
        label={label}
        unit={metric.units}
        value={value}
      />
    );
  }
  return <span>{metric.getValue(data) ?? BLANK_VALUE}</span>;
};
